<template>
  <div class="Content_analysis">
    <el-dialog :visible.sync="dialogVisible" width="700px" :before-close="handleClose" >
      <div id="main" ref="myechart" style="width: 660px;height: 500px;"></div>
    </el-dialog>



    <el-form  style="padding:20px;background-color: #fff;" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="综合查询">
        <el-input v-model="formInline.Name" placeholder="请输入发布人，标题查询"></el-input>
      </el-form-item>
      <el-form-item label="内容形式">
        <el-select v-model="formInline.MaterialType" placeholder="请选择内容形式">
          <el-option label="文章" value="1"></el-option>
          <el-option label="视频" value="4"></el-option>
          <el-option label="音频" value="3"></el-option>
          <el-option label="图片" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="栏目">
        <el-cascader ref="wcascader" v-model="formInline.ItemKey" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable placeholder="请选择栏目"></el-cascader>
      </el-form-item>
      <el-form-item label="发布时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="formInline.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="resetfun()">重置</el-button>
      </el-form-item>
    </el-form>
    <div style="width: 100%;margin-top:16px;background-color: #fff;height: calc(100% - 120px);">
      <el-table :data="tableData" style="width: 98%;margin-left:1%;padding-top:16px;">
        <el-table-column prop="MaterialName" label="标题" ></el-table-column>
        <el-table-column prop="Creator" label="发布人"></el-table-column>
        <el-table-column prop="MaterialType" label="内容形式"></el-table-column>
        <el-table-column prop="ReleaseTime" label="发布时间"></el-table-column>
        <el-table-column prop="ReadingVolume" label="阅读量"></el-table-column>
        <el-table-column prop="Likes" label="点赞量"></el-table-column>
        <el-table-column prop="ForwardingVolume" label="转发量"></el-table-column>
        <el-table-column prop="CommentStatistic" label="评论统计"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span style="margin-left: 10px;cursor:pointer;color: rgb(31, 52, 245);" @click="re_look(scope.row.MaterialKey, scope.row.MaterialType)">{{scope.row.status == '已驳回'?'驳回原因':'查看'}}</span>
            <!-- <span v-if="scope.row.MaterialType=='文章'" style="margin-left: 10px;cursor:pointer;color: rgb(31, 52, 245);" @click="Preview(scope.row.MaterialKey, scope.row.MaterialType)">预览</span> -->
            <span style="margin-left: 10px;cursor:pointer;color: rgb(31, 52, 245);" @click="qs(scope.row)">趋势图</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="formInline.pageIndex" :page-size="formInline.pageSize" layout="total, prev, pager, next" :total="UndoCount"></el-pagination>
    </div>


  


    <!-- 文章弹窗 -->
    <el-dialog :visible.sync="Articledialog" width="640px" top="10vh" :before-close="handleClose">
      <div class="Articlecontent">
        <div v-html="Article"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formInline: {
        PageSize: 10,
        PageIndex: 1,
        MaterialType: "",//内容形式
        Name: "",//标题、发布人查询
        ItemKey: "",//栏目
        time: [],
        StartTime: "",//开始时间
        EndTime: ""//结束时间
      },
      dialogVisible: true,
      data: [],
      tableData: [],
      UndoCount: 1,
      tit:'',
      Articledialog:false,
      Article:''
    }
  },
  mounted() {
    this.dialogVisible = false;
    this.$Http_Post('management/getColumnManagementByNode', { PItemKey: '0', pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })
    this.loading();
  },
  methods: {
    resetfun() {
      this.formInline = {
        PageSize: 10,
        PageIndex: 1,
        MaterialType: "",//内容形式
        Name: "",//标题、发布人查询
        ItemKey: "",//栏目
        time: [],
        StartTime: "",//开始时间
        EndTime: ""//结束时间
      }
      this.loading();
    },
    qs(row) {
      this.$Http_Post('management/trendChart', { MaterialKey: row.MaterialKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tit = row.MaterialName;
          this.dialogVisible = true;
          var myChart = this.$echarts.init(this.$refs.myechart);
          var option = {
            title: {
              text: this.tit + "的趋势图"
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['阅读量', '点赞量', '转发量', '评论量'],
              top: 30,
            },
            color: ['#fc8251', '#5470c6', '#91cd77', '#ef6567'],
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: res.Data.month
            },
            yAxis: {
              type: 'value',
            },
            series: [
              {
                name: '阅读量',
                type: 'line',
                data: res.Data.readVolume
              },
              {
                name: '点赞量',
                type: 'line',
                data: res.Data.likesNum
              },
              {
                name: '转发量',
                type: 'line',
                data: res.Data.forwardNum
              },
              {
                name: '评论量',
                type: 'line',
                data: res.Data.commentNum
              }
            ]
          };
          console.log(res.Data.readVolume)
          console.log(res.Data.likesNum)
          console.log(res.Data.forwardNum)
          console.log(res.Data.commentNum)
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });

        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    re_look(materialKey, materialType) {//查看
      if (materialType == "音频") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 1, Source: 3 },
        })
      } else if (materialType == "视频") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 2 , Source: 3 },
        })
      } else if (materialType == "图片") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 3 , Source: 3 },
        })
      }else if (materialType == "文章") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 4 , Source: 3 },
        })
      }
    },

    // 预览
    Preview(materialKey){
      this.$Http_Post('management/getContentDetails',{MaterialKey:materialKey}).then(res=>{
          if(res.Code==200 || res.Code==0){
            this.Articledialog=true;
            this.Article=res.Data.richTextContent
          }else{
            this.$message({type: 'error', message:res.Message});
          }
        });
    },
    handleCurrentChange(val) {
      this.formInline.PageIndex = val;
      this.loading();
    },
    onSubmit() {
      this.formInline.PageIndex = 1;
      this.loading();
    },
    loading() {
      this.$Http_Post('management/contentAnalysis', {MaterialType: this.formInline.MaterialType,Name: this.formInline.Name,ItemKey: this.formInline.ItemKey,PageSize: this.formInline.PageSize,PageIndex: this.formInline.PageIndex,RoleID:sessionStorage.getItem('RoleID'),StartTime: this.formInline.time[0],EndTime: this.formInline.time[1],}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.UndoCount = res.Counts;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
      .then(_ => {
        done();
      })
      .catch(_ => {});
    },
    Selected_to_shut_dow(dt) {
      this.formInline.ItemKey = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].value == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].value != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },
    bumen(dt) {
      let obj = this.data[0];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].value == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].value != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }

      if (obj.fuzi && obj.children.length > 0 && obj.children[0].value == '-2') {
        obj.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/management/getColumnManagementByNode', { PItemKey: dt[dt.length - 1], pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }

    },
  },
}
</script>
<style>
.Content_analysis{width: 100%;height: 100%;}
</style>
